import React from "react";

function MobLogoSvg() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0650273 25.3207C0.843327 24.9421 1.61729 24.5453 2.37301 24.0762C2.6657 23.8616 2.93595 23.5945 3.18382 23.2753C3.30933 22.989 3.48036 22.6997 3.60678 22.4078C6.4784 15.779 9.55622 7.71697 12.5449 0.419996C12.7679 -0.0989641 13.31 -0.179584 13.5983 0.419996L17.944 10.375L14.33 12.2092L12.2632 7.28828L6.74046 21.1957L5.61081 22.1372L6.84318 24.4548L6.01489 24.9467L4.9146 22.9275L4.57869 23.1526L5.32266 24.6306L3.63768 25.6167H0L0.0650273 25.3207Z"
        fill="#F37E1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.13281 22.2393L15.0458 17.793L15.7466 19.2724L6.85993 23.75L6.13281 22.2393Z"
        fill="#7B0100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1914 14.801L19.0173 12.4141L19.3315 13.0775L14.5319 15.4957L14.1914 14.801Z"
        fill="#7B0100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3867 20.9769L22.2125 18.5898L22.5267 19.2534L17.7271 21.6716L17.3867 20.9769Z"
        fill="#7B0100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6369 13.6472L18.4684 11.2076C18.7141 11.0835 19.049 11.1819 19.136 11.4427L19.136 11.4429C19.2229 11.7038 19.1465 11.9865 18.901 12.1104L14.0694 14.5501C13.8239 14.674 13.4888 14.576 13.4019 14.315L13.4018 14.3148C13.3148 14.0538 13.3912 13.7714 13.6369 13.6472Z"
        fill="#7B0100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8283 21.9578L22.6598 19.5182C22.9054 19.3941 23.2404 19.4924 23.3273 19.7532L23.3274 19.7534C23.4144 20.0143 23.3378 20.297 23.0923 20.4209L18.2609 22.8606C18.0154 22.9846 17.6802 22.8866 17.5933 22.6256L17.5932 22.6253C17.5063 22.3643 17.5826 22.0819 17.8283 21.9578Z"
        fill="#7B0100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0593 23.918H25.4461C25.7258 23.918 25.9546 24.1468 25.9546 24.4265V24.9351H16.5508V24.4265C16.5508 24.1468 16.7796 23.918 17.0593 23.918H17.0593Z"
        fill="#F37E1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.348 23.4082H25.1566C25.2966 23.4082 25.4109 23.5227 25.4109 23.6624V23.9167H17.0938V23.6624C17.0938 23.5226 17.2081 23.4082 17.3479 23.4082H17.348Z"
        fill="#F37E1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3672 15.8441L16.9364 20.9079L22.2988 18.2555L19.7002 13.1777L14.3672 15.8441Z"
        fill="#7B0100"
      />
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="28"
    //   height="31"
    //   fill="none"
    //   viewBox="0 0 28 31"
    // >
    //   <path
    //     fill="#1C64F2"
    //     d="M13.943 14.73l3.197-7.664-2.524-5.624L13.962 0l-.673 1.461L0 31h6.592l4.938-10.846h-.01l2.423-5.424z"
    //   ></path>
    //   <path
    //     fill="#111928"
    //     d="M19.547 12.426l-3.176 7.696.015.032h-.028l.01.01-.147.324-2.417 5.858h5.37l.096.232 2 4.422h6.616l-8.34-18.574z"
    //   ></path>
    // </svg>
  );
}

export default MobLogoSvg;
